// extracted by mini-css-extract-plugin
module.exports = {"container":"mazes_container__1IDUI","button":"mazes_button__2urkM"};